<template>
  <div class="decoupe">
    <div class="row">
      <div class="col s6">
        <select-number v-on:change="quantity = $event" id="quantity" label="Quantité"></select-number>
      </div>
      <div class="col s6">
        <select-number v-on:change="length = $event" id="length" label="Longueur (ML)"></select-number>
      </div>
    </div>

    <div class="row">
      <div v-if="product.coefficient !== 1" class="col s6">
        <info id="width" label="Largeur (ML)" :value="product.coefficient"></info>
      </div>
      <div class="col s6">
        <info id="price" label="Prix" :value="(product.price * product.coefficient).toFixed(2)+'€'"></info>
      </div>
    </div>

    <div class="row">
      <div v-bind:class="[product.coefficient !== 1 ? 's4' : 's6', 'col']">
        <info value="TOTAL"></info>
      </div>
      <div
        v-if="product.coefficient !== 1"
        v-bind:class="[product.coefficient !== 1 ? 's4' : 's6', 'col']"
      >
        <info :value="(product.coefficient * quantity * length).toFixed(2)+'M²'"></info>
      </div>
      <div v-bind:class="[product.coefficient !== 1 ? 's4' : 's6', 'col']">
        <info :value="(product.price * product.coefficient * quantity * length).toFixed(2)+'€'"></info>
      </div>
    </div>

    <div class="center-align">
      <add-to-basket v-bind:product="product" v-bind:quantity="quantity" v-bind:length="length"></add-to-basket>
    </div>
  </div>
</template>

<script>
import Info from "./Info.vue";
import SelectNumber from "@/components/SelectNumber.vue";
import AddToBasket from "@/components/Product/AddToBasket.vue";

export default {
  props: ["product"],
  data() {
    return {
      quantity: 0,
      length: 0
    };
  },
  components: {
    Info,
    SelectNumber,
    AddToBasket
  }
};
</script>
